module.exports = [
  "Abilene",
  "Akron",
  "Alafaya",
  "Alameda",
  "Albany",
  "Albany",
  "Albany",
  "Albuquerque",
  "Alexandria",
  "Alexandria",
  "Alhambra",
  "Aliso Viejo",
  "Allen",
  "Allentown",
  "Aloha",
  "Alpharetta",
  "Altadena",
  "Altamonte Springs",
  "Altoona",
  "Amarillo",
  "Ames",
  "Anaheim",
  "Anchorage",
  "Anderson",
  "Ankeny",
  "Ann Arbor",
  "Annandale",
  "Antelope",
  "Antioch",
  "Apex",
  "Apopka",
  "Apple Valley",
  "Apple Valley",
  "Appleton",
  "Arcadia",
  "Arden-Arcade",
  "Arecibo",
  "Arlington",
  "Arlington",
  "Arlington",
  "Arlington Heights",
  "Arvada",
  "Ashburn",
  "Asheville",
  "Aspen Hill",
  "Atascocita",
  "Athens-Clarke County",
  "Atlanta",
  "Attleboro",
  "Auburn",
  "Auburn",
  "Augusta-Richmond County",
  "Aurora",
  "Aurora",
  "Austin",
  "Avondale",
  "Azusa",
  "Bakersfield",
  "Baldwin Park",
  "Baltimore",
  "Barnstable Town",
  "Bartlett",
  "Bartlett",
  "Baton Rouge",
  "Battle Creek",
  "Bayamon",
  "Bayonne",
  "Baytown",
  "Beaumont",
  "Beaumont",
  "Beavercreek",
  "Beaverton",
  "Bedford",
  "Bel Air South",
  "Bell Gardens",
  "Belleville",
  "Bellevue",
  "Bellevue",
  "Bellflower",
  "Bellingham",
  "Bend",
  "Bentonville",
  "Berkeley",
  "Berwyn",
  "Bethesda",
  "Bethlehem",
  "Billings",
  "Biloxi",
  "Binghamton",
  "Birmingham",
  "Bismarck",
  "Blacksburg",
  "Blaine",
  "Bloomington",
  "Bloomington",
  "Bloomington",
  "Blue Springs",
  "Boca Raton",
  "Boise City",
  "Bolingbrook",
  "Bonita Springs",
  "Bossier City",
  "Boston",
  "Bothell",
  "Boulder",
  "Bountiful",
  "Bowie",
  "Bowling Green",
  "Boynton Beach",
  "Bozeman",
  "Bradenton",
  "Brandon",
  "Brentwood",
  "Brentwood",
  "Bridgeport",
  "Bristol",
  "Brockton",
  "Broken Arrow",
  "Brookhaven",
  "Brookline",
  "Brooklyn Park",
  "Broomfield",
  "Brownsville",
  "Bryan",
  "Buckeye",
  "Buena Park",
  "Buffalo",
  "Buffalo Grove",
  "Burbank",
  "Burien",
  "Burke",
  "Burleson",
  "Burlington",
  "Burlington",
  "Burnsville",
  "Caguas",
  "Caldwell",
  "Camarillo",
  "Cambridge",
  "Camden",
  "Canton",
  "Cape Coral",
  "Carlsbad",
  "Carmel",
  "Carmichael",
  "Carolina",
  "Carrollton",
  "Carson",
  "Carson City",
  "Cary",
  "Casa Grande",
  "Casas Adobes",
  "Casper",
  "Castle Rock",
  "Castro Valley",
  "Catalina Foothills",
  "Cathedral City",
  "Catonsville",
  "Cedar Hill",
  "Cedar Park",
  "Cedar Rapids",
  "Centennial",
  "Centreville",
  "Ceres",
  "Cerritos",
  "Champaign",
  "Chandler",
  "Chapel Hill",
  "Charleston",
  "Charleston",
  "Charlotte",
  "Charlottesville",
  "Chattanooga",
  "Cheektowaga",
  "Chesapeake",
  "Chesterfield",
  "Cheyenne",
  "Chicago",
  "Chico",
  "Chicopee",
  "Chino",
  "Chino Hills",
  "Chula Vista",
  "Cicero",
  "Cincinnati",
  "Citrus Heights",
  "Clarksville",
  "Clearwater",
  "Cleveland",
  "Cleveland",
  "Cleveland Heights",
  "Clifton",
  "Clovis",
  "Coachella",
  "Coconut Creek",
  "Coeur d'Alene",
  "College Station",
  "Collierville",
  "Colorado Springs",
  "Colton",
  "Columbia",
  "Columbia",
  "Columbia",
  "Columbus",
  "Columbus",
  "Columbus",
  "Commerce City",
  "Compton",
  "Concord",
  "Concord",
  "Concord",
  "Conroe",
  "Conway",
  "Coon Rapids",
  "Coral Gables",
  "Coral Springs",
  "Corona",
  "Corpus Christi",
  "Corvallis",
  "Costa Mesa",
  "Council Bluffs",
  "Country Club",
  "Covina",
  "Cranston",
  "Cupertino",
  "Cutler Bay",
  "Cuyahoga Falls",
  "Cypress",
  "Dale City",
  "Dallas",
  "Daly City",
  "Danbury",
  "Danville",
  "Danville",
  "Davenport",
  "Davie",
  "Davis",
  "Dayton",
  "Daytona Beach",
  "DeKalb",
  "DeSoto",
  "Dearborn",
  "Dearborn Heights",
  "Decatur",
  "Decatur",
  "Deerfield Beach",
  "Delano",
  "Delray Beach",
  "Deltona",
  "Denton",
  "Denver",
  "Des Moines",
  "Des Plaines",
  "Detroit",
  "Diamond Bar",
  "Doral",
  "Dothan",
  "Downers Grove",
  "Downey",
  "Draper",
  "Dublin",
  "Dublin",
  "Dubuque",
  "Duluth",
  "Dundalk",
  "Dunwoody",
  "Durham",
  "Eagan",
  "East Hartford",
  "East Honolulu",
  "East Lansing",
  "East Los Angeles",
  "East Orange",
  "East Providence",
  "Eastvale",
  "Eau Claire",
  "Eden Prairie",
  "Edina",
  "Edinburg",
  "Edmond",
  "El Cajon",
  "El Centro",
  "El Dorado Hills",
  "El Monte",
  "El Paso",
  "Elgin",
  "Elizabeth",
  "Elk Grove",
  "Elkhart",
  "Ellicott City",
  "Elmhurst",
  "Elyria",
  "Encinitas",
  "Enid",
  "Enterprise",
  "Erie",
  "Escondido",
  "Euclid",
  "Eugene",
  "Euless",
  "Evanston",
  "Evansville",
  "Everett",
  "Everett",
  "Fairfield",
  "Fairfield",
  "Fall River",
  "Fargo",
  "Farmington",
  "Farmington Hills",
  "Fayetteville",
  "Fayetteville",
  "Federal Way",
  "Findlay",
  "Fishers",
  "Flagstaff",
  "Flint",
  "Florence-Graham",
  "Florin",
  "Florissant",
  "Flower Mound",
  "Folsom",
  "Fond du Lac",
  "Fontana",
  "Fort Collins",
  "Fort Lauderdale",
  "Fort Myers",
  "Fort Pierce",
  "Fort Smith",
  "Fort Wayne",
  "Fort Worth",
  "Fountain Valley",
  "Fountainebleau",
  "Framingham",
  "Franklin",
  "Frederick",
  "Freeport",
  "Fremont",
  "Fresno",
  "Frisco",
  "Fullerton",
  "Gainesville",
  "Gaithersburg",
  "Galveston",
  "Garden Grove",
  "Gardena",
  "Garland",
  "Gary",
  "Gastonia",
  "Georgetown",
  "Germantown",
  "Gilbert",
  "Gilroy",
  "Glen Burnie",
  "Glendale",
  "Glendale",
  "Glendora",
  "Glenview",
  "Goodyear",
  "Grand Forks",
  "Grand Island",
  "Grand Junction",
  "Grand Prairie",
  "Grand Rapids",
  "Grapevine",
  "Great Falls",
  "Greeley",
  "Green Bay",
  "Greensboro",
  "Greenville",
  "Greenville",
  "Greenwood",
  "Gresham",
  "Guaynabo",
  "Gulfport",
  "Hacienda Heights",
  "Hackensack",
  "Haltom City",
  "Hamilton",
  "Hammond",
  "Hampton",
  "Hanford",
  "Harlingen",
  "Harrisburg",
  "Harrisonburg",
  "Hartford",
  "Hattiesburg",
  "Haverhill",
  "Hawthorne",
  "Hayward",
  "Hemet",
  "Hempstead",
  "Henderson",
  "Hendersonville",
  "Hesperia",
  "Hialeah",
  "Hicksville",
  "High Point",
  "Highland",
  "Highlands Ranch",
  "Hillsboro",
  "Hilo",
  "Hoboken",
  "Hoffman Estates",
  "Hollywood",
  "Homestead",
  "Honolulu",
  "Hoover",
  "Houston",
  "Huntersville",
  "Huntington",
  "Huntington Beach",
  "Huntington Park",
  "Huntsville",
  "Hutchinson",
  "Idaho Falls",
  "Independence",
  "Indianapolis",
  "Indio",
  "Inglewood",
  "Iowa City",
  "Irondequoit",
  "Irvine",
  "Irving",
  "Jackson",
  "Jackson",
  "Jacksonville",
  "Jacksonville",
  "Janesville",
  "Jefferson City",
  "Jeffersonville",
  "Jersey City",
  "Johns Creek",
  "Johnson City",
  "Joliet",
  "Jonesboro",
  "Joplin",
  "Jupiter",
  "Jurupa Valley",
  "Kalamazoo",
  "Kannapolis",
  "Kansas City",
  "Kansas City",
  "Kearny",
  "Keller",
  "Kendale Lakes",
  "Kendall",
  "Kenner",
  "Kennewick",
  "Kenosha",
  "Kent",
  "Kentwood",
  "Kettering",
  "Killeen",
  "Kingsport",
  "Kirkland",
  "Kissimmee",
  "Knoxville",
  "Kokomo",
  "La Crosse",
  "La Habra",
  "La Mesa",
  "La Mirada",
  "Lacey",
  "Lafayette",
  "Lafayette",
  "Laguna Niguel",
  "Lake Charles",
  "Lake Elsinore",
  "Lake Forest",
  "Lake Havasu City",
  "Lake Ridge",
  "Lakeland",
  "Lakeville",
  "Lakewood",
  "Lakewood",
  "Lakewood",
  "Lakewood",
  "Lakewood",
  "Lancaster",
  "Lancaster",
  "Lansing",
  "Laredo",
  "Largo",
  "Las Cruces",
  "Las Vegas",
  "Lauderhill",
  "Lawrence",
  "Lawrence",
  "Lawrence",
  "Lawton",
  "Layton",
  "League City",
  "Lee's Summit",
  "Leesburg",
  "Lehi",
  "Lehigh Acres",
  "Lenexa",
  "Levittown",
  "Levittown",
  "Lewisville",
  "Lexington-Fayette",
  "Lincoln",
  "Lincoln",
  "Linden",
  "Little Rock",
  "Littleton",
  "Livermore",
  "Livonia",
  "Lodi",
  "Logan",
  "Lombard",
  "Lompoc",
  "Long Beach",
  "Longmont",
  "Longview",
  "Lorain",
  "Los Angeles",
  "Louisville/Jefferson County",
  "Loveland",
  "Lowell",
  "Lubbock",
  "Lynchburg",
  "Lynn",
  "Lynwood",
  "Macon-Bibb County",
  "Madera",
  "Madison",
  "Madison",
  "Malden",
  "Manchester",
  "Manhattan",
  "Mansfield",
  "Mansfield",
  "Manteca",
  "Maple Grove",
  "Margate",
  "Maricopa",
  "Marietta",
  "Marysville",
  "Mayaguez",
  "McAllen",
  "McKinney",
  "McLean",
  "Medford",
  "Medford",
  "Melbourne",
  "Memphis",
  "Menifee",
  "Mentor",
  "Merced",
  "Meriden",
  "Meridian",
  "Mesa",
  "Mesquite",
  "Metairie",
  "Methuen Town",
  "Miami",
  "Miami Beach",
  "Miami Gardens",
  "Middletown",
  "Middletown",
  "Midland",
  "Midland",
  "Midwest City",
  "Milford",
  "Millcreek",
  "Milpitas",
  "Milwaukee",
  "Minneapolis",
  "Minnetonka",
  "Minot",
  "Miramar",
  "Mishawaka",
  "Mission",
  "Mission Viejo",
  "Missoula",
  "Missouri City",
  "Mobile",
  "Modesto",
  "Moline",
  "Monroe",
  "Montebello",
  "Monterey Park",
  "Montgomery",
  "Moore",
  "Moreno Valley",
  "Morgan Hill",
  "Mount Pleasant",
  "Mount Prospect",
  "Mount Vernon",
  "Mountain View",
  "Muncie",
  "Murfreesboro",
  "Murray",
  "Murrieta",
  "Nampa",
  "Napa",
  "Naperville",
  "Nashua",
  "Nashville-Davidson",
  "National City",
  "New Bedford",
  "New Braunfels",
  "New Britain",
  "New Brunswick",
  "New Haven",
  "New Orleans",
  "New Rochelle",
  "New York",
  "Newark",
  "Newark",
  "Newark",
  "Newport Beach",
  "Newport News",
  "Newton",
  "Niagara Falls",
  "Noblesville",
  "Norfolk",
  "Normal",
  "Norman",
  "North Bethesda",
  "North Charleston",
  "North Highlands",
  "North Las Vegas",
  "North Lauderdale",
  "North Little Rock",
  "North Miami",
  "North Miami Beach",
  "North Port",
  "North Richland Hills",
  "Norwalk",
  "Norwalk",
  "Novato",
  "Novi",
  "O'Fallon",
  "Oak Lawn",
  "Oak Park",
  "Oakland",
  "Oakland Park",
  "Ocala",
  "Oceanside",
  "Odessa",
  "Ogden",
  "Oklahoma City",
  "Olathe",
  "Olympia",
  "Omaha",
  "Ontario",
  "Orange",
  "Orem",
  "Orland Park",
  "Orlando",
  "Oro Valley",
  "Oshkosh",
  "Overland Park",
  "Owensboro",
  "Oxnard",
  "Palatine",
  "Palm Bay",
  "Palm Beach Gardens",
  "Palm Coast",
  "Palm Desert",
  "Palm Harbor",
  "Palm Springs",
  "Palmdale",
  "Palo Alto",
  "Paradise",
  "Paramount",
  "Parker",
  "Parma",
  "Pasadena",
  "Pasadena",
  "Pasco",
  "Passaic",
  "Paterson",
  "Pawtucket",
  "Peabody",
  "Pearl City",
  "Pearland",
  "Pembroke Pines",
  "Pensacola",
  "Peoria",
  "Peoria",
  "Perris",
  "Perth Amboy",
  "Petaluma",
  "Pflugerville",
  "Pharr",
  "Philadelphia",
  "Phoenix",
  "Pico Rivera",
  "Pine Bluff",
  "Pine Hills",
  "Pinellas Park",
  "Pittsburg",
  "Pittsburgh",
  "Pittsfield",
  "Placentia",
  "Plainfield",
  "Plainfield",
  "Plano",
  "Plantation",
  "Pleasanton",
  "Plymouth",
  "Pocatello",
  "Poinciana",
  "Pomona",
  "Pompano Beach",
  "Ponce",
  "Pontiac",
  "Port Arthur",
  "Port Charlotte",
  "Port Orange",
  "Port St. Lucie",
  "Portage",
  "Porterville",
  "Portland",
  "Portland",
  "Portsmouth",
  "Potomac",
  "Poway",
  "Providence",
  "Provo",
  "Pueblo",
  "Quincy",
  "Racine",
  "Raleigh",
  "Rancho Cordova",
  "Rancho Cucamonga",
  "Rancho Palos Verdes",
  "Rancho Santa Margarita",
  "Rapid City",
  "Reading",
  "Redding",
  "Redlands",
  "Redmond",
  "Redondo Beach",
  "Redwood City",
  "Reno",
  "Renton",
  "Reston",
  "Revere",
  "Rialto",
  "Richardson",
  "Richland",
  "Richmond",
  "Richmond",
  "Rio Rancho",
  "Riverside",
  "Riverton",
  "Riverview",
  "Roanoke",
  "Rochester",
  "Rochester",
  "Rochester Hills",
  "Rock Hill",
  "Rockford",
  "Rocklin",
  "Rockville",
  "Rockwall",
  "Rocky Mount",
  "Rogers",
  "Rohnert Park",
  "Rosemead",
  "Roseville",
  "Roseville",
  "Roswell",
  "Roswell",
  "Round Rock",
  "Rowland Heights",
  "Rowlett",
  "Royal Oak",
  "Sacramento",
  "Saginaw",
  "Salem",
  "Salem",
  "Salina",
  "Salinas",
  "Salt Lake City",
  "Sammamish",
  "San Angelo",
  "San Antonio",
  "San Bernardino",
  "San Bruno",
  "San Buenaventura (Ventura)",
  "San Clemente",
  "San Diego",
  "San Francisco",
  "San Jacinto",
  "San Jose",
  "San Juan",
  "San Leandro",
  "San Luis Obispo",
  "San Marcos",
  "San Marcos",
  "San Mateo",
  "San Rafael",
  "San Ramon",
  "San Tan Valley",
  "Sandy",
  "Sandy Springs",
  "Sanford",
  "Santa Ana",
  "Santa Barbara",
  "Santa Clara",
  "Santa Clarita",
  "Santa Cruz",
  "Santa Fe",
  "Santa Maria",
  "Santa Monica",
  "Santa Rosa",
  "Santee",
  "Sarasota",
  "Savannah",
  "Sayreville",
  "Schaumburg",
  "Schenectady",
  "Scottsdale",
  "Scranton",
  "Seattle",
  "Severn",
  "Shawnee",
  "Sheboygan",
  "Shoreline",
  "Shreveport",
  "Sierra Vista",
  "Silver Spring",
  "Simi Valley",
  "Sioux City",
  "Sioux Falls",
  "Skokie",
  "Smyrna",
  "Smyrna",
  "Somerville",
  "South Bend",
  "South Gate",
  "South Hill",
  "South Jordan",
  "South San Francisco",
  "South Valley",
  "South Whittier",
  "Southaven",
  "Southfield",
  "Sparks",
  "Spokane",
  "Spokane Valley",
  "Spring",
  "Spring Hill",
  "Spring Valley",
  "Springdale",
  "Springfield",
  "Springfield",
  "Springfield",
  "Springfield",
  "Springfield",
  "St. Charles",
  "St. Clair Shores",
  "St. Cloud",
  "St. Cloud",
  "St. George",
  "St. Joseph",
  "St. Louis",
  "St. Louis Park",
  "St. Paul",
  "St. Peters",
  "St. Petersburg",
  "Stamford",
  "State College",
  "Sterling Heights",
  "Stillwater",
  "Stockton",
  "Stratford",
  "Strongsville",
  "Suffolk",
  "Sugar Land",
  "Summerville",
  "Sunnyvale",
  "Sunrise",
  "Sunrise Manor",
  "Surprise",
  "Syracuse",
  "Tacoma",
  "Tallahassee",
  "Tamarac",
  "Tamiami",
  "Tampa",
  "Taunton",
  "Taylor",
  "Taylorsville",
  "Temecula",
  "Tempe",
  "Temple",
  "Terre Haute",
  "Texas City",
  "The Hammocks",
  "The Villages",
  "The Woodlands",
  "Thornton",
  "Thousand Oaks",
  "Tigard",
  "Tinley Park",
  "Titusville",
  "Toledo",
  "Toms River",
  "Tonawanda",
  "Topeka",
  "Torrance",
  "Town 'n' Country",
  "Towson",
  "Tracy",
  "Trenton",
  "Troy",
  "Troy",
  "Trujillo Alto",
  "Tuckahoe",
  "Tucson",
  "Tulare",
  "Tulsa",
  "Turlock",
  "Tuscaloosa",
  "Tustin",
  "Twin Falls",
  "Tyler",
  "Union City",
  "Union City",
  "University",
  "Upland",
  "Urbana",
  "Urbandale",
  "Utica",
  "Vacaville",
  "Valdosta",
  "Vallejo",
  "Vancouver",
  "Victoria",
  "Victorville",
  "Vineland",
  "Virginia Beach",
  "Visalia",
  "Vista",
  "Waco",
  "Waipahu",
  "Waldorf",
  "Walnut Creek",
  "Waltham",
  "Warner Robins",
  "Warren",
  "Warwick",
  "Washington",
  "Waterbury",
  "Waterloo",
  "Watsonville",
  "Waukegan",
  "Waukesha",
  "Wauwatosa",
  "Wellington",
  "Wesley Chapel",
  "West Allis",
  "West Babylon",
  "West Covina",
  "West Des Moines",
  "West Hartford",
  "West Haven",
  "West Jordan",
  "West Lafayette",
  "West New York",
  "West Palm Beach",
  "West Sacramento",
  "West Seneca",
  "West Valley City",
  "Westfield",
  "Westland",
  "Westminster",
  "Westminster",
  "Weston",
  "Weymouth Town",
  "Wheaton",
  "Wheaton",
  "White Plains",
  "Whittier",
  "Wichita",
  "Wichita Falls",
  "Wilmington",
  "Wilmington",
  "Wilson",
  "Winston-Salem",
  "Woodbury",
  "Woodland",
  "Worcester",
  "Wylie",
  "Wyoming",
  "Yakima",
  "Yonkers",
  "Yorba Linda",
  "York",
  "Youngstown",
  "Yuba City",
  "Yucaipa",
  "Yuma"
];